import React from 'react'
import PropTypes from 'prop-types'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import ContentBox from '../../../layout/component/ContentBox'
import moment from 'moment'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TREATMENT_FEEDBACK_WIDGET } from '../../../process/ui-definition/process-ui'




const Feeback = ({satisfactionScore, created, comment, alignerNumberUpper, alignerNumberLower}) => {
    const date = moment.utc(created).format('YYYY-MM-DD HH:mm')

    return (<tr>
        <td>{date}</td>
        <td>{alignerNumberLower}</td>
        <td>{alignerNumberUpper}</td>
        <td>{satisfactionScore}</td>
        <td style={{maxWidth: 200}}>{comment}</td>
    </tr>)
}


const TreatmentFeedback = ({ customer }) => {
    if (!currentUserHasAccess(TREATMENT_FEEDBACK_WIDGET)) {
        return null
    }
    if (!customer.treatmentExecutionList || !customer.treatmentExecutionList.length) {
        return null
    }

    const feedbackList = customer.treatmentExecutionList.reduce((accumulator, current) => accumulator.concat(current.treatmentFeedbackList), [])

    return (
        <ContentBox title="Treatment Feedback">
            <Row>
                <Column>
                    <table className="customer-form-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Lower</th>
                                <th>Upper</th>
                                <th>Satisfaction</th>
                                <th>Feedback</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                feedbackList.map((feedback, index) => {
                                    return <Feeback key={index} {...feedback} />
                                })
                            }
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}


TreatmentFeedback.propTypes = {
    customer: PropTypes.object,
}

export default TreatmentFeedback



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TreatmentFeedback.js